import React from 'react';

export default function RequiredIndicator({ required }) {
  if (!required) return null;

  return (
    <span className='text-danger'> *</span>
  );
}